module.exports = __webpack_public_path__ + "static/devops-0db6b9fe5f56e1c752e40ff4e8dda439.svg";